export default "__VITE_ASSET__DRtM_Fsc__"